export const isLargeScreenMediaQuery = "(min-width: 107em)";
